import { render, staticRenderFns } from "./modelOne.vue?vue&type=template&id=67f1b706&scoped=true&"
import script from "./modelOne.vue?vue&type=script&lang=js&"
export * from "./modelOne.vue?vue&type=script&lang=js&"
import style0 from "./modelOne.vue?vue&type=style&index=0&id=67f1b706&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f1b706",
  null
  
)

export default component.exports